import '../styles/arrow.less';
import '../styles/messageBox.less';
import $ from 'jquery';
import * as common from '../../../shared/modules/common';

var supportedTypes = ['info', 'warning', 'emptyvalue', 'no-message', 'error', 'confirmation', 'confirmation-white',
                        'confirmation-ghost',
                        'neutral', 'mail', 'spotlight'], // UW4 types
    supportedIconTypes = ['none', 'small'];

function getType($mb) {
    var type = $mb.data('type');
    return $.inArray(type, supportedTypes) >= 0 ? type : 'info';
}

function getIconType($mb) {
    var iconType = $mb.data('icon-type');
    return $.inArray(iconType, supportedIconTypes) >= 0 ? iconType : 'small';
}

function initSingle($mb) {
    var typeClass = 'uwr-message-box-type-' + getType($mb),
        iconTypeClass = 'uwr-message-box-icon-' + getIconType($mb),
        inited = $mb.hasClass(typeClass);

    if (!inited) {
        $mb.addClass(typeClass);
        $mb.addClass(iconTypeClass);
        $mb.wrapInner('<div class="uwr-message-box-content" />');
    }
}

/**
 * Supported use cases:
 * - init();
 * - init(callback);
 * - init(selector);
 * - init(selector, callback);
 */
export function init(arg1, arg2) {
    var selector,
        callback;

    if (arguments.length === 0) {
        selector = '.uwr-message-box';
        callback = null;
    } else if (arguments.length === 1) {
        if ($.type(arg1) === 'string') {
            selector = arg1;
            callback = null;
        } else if ($.type(arg1) === 'function') {
            selector = '.uwr-message-box';
            callback = arg1;
        }
    } else if (arguments.length === 2) {
        selector = arg1;
        callback = arg2;
    }

    $(selector).each(function (i, el) {
        var $mb = $(el);
        if ($mb.hasClass('uwr-message-box')) {
            initSingle($mb);
        }
    });

    common.invoke(callback);
}



//////////////////
// WEBPACK FOOTER
// ./widgets/MessageBox/js/messageBox.js
// module id = 12
// module chunks = main